import { and, eq } from "drizzle-orm";
import {
  docType, stockMovements, settlementMovements, cashMovements,
} from "@briolin/db";
import type { TestDb } from "@briolin/db/src/testing.js";

type Db = TestDb;
export type DocTypeValue = (typeof docType.enumValues)[number];

export type StockMovementInput = { productId: string; warehouseId: string; qtyDelta: number; kind: "physical" | "reserve" };
export type SettlementMovementInput = { counterpartyId: string; amountDeltaKopecks: number };
export type CashMovementInput = { cashAccountId: string; amountDeltaKopecks: number; cashflowCategoryId?: string };
export type DocumentMovements = {
  stock?: StockMovementInput[];
  settlement?: SettlementMovementInput[];
  cash?: CashMovementInput[];
};
export type DocRef = { docType: DocTypeValue; docId: string; date: Date };

async function deleteMovements(tx: Db, dt: DocTypeValue, docId: string): Promise<void> {
  await tx.delete(stockMovements).where(and(eq(stockMovements.docType, dt), eq(stockMovements.docId, docId)));
  await tx.delete(settlementMovements).where(and(eq(settlementMovements.docType, dt), eq(settlementMovements.docId, docId)));
  await tx.delete(cashMovements).where(and(eq(cashMovements.docType, dt), eq(cashMovements.docId, docId)));
}

export async function postDocument(db: Db, ref: DocRef, m: DocumentMovements): Promise<void> {
  await db.transaction(async (tx) => {
    await deleteMovements(tx as unknown as Db, ref.docType, ref.docId);
    if (m.stock?.length) {
      await tx.insert(stockMovements).values(m.stock.map((s) => ({
        productId: s.productId, warehouseId: s.warehouseId, qtyDelta: s.qtyDelta, kind: s.kind,
        docType: ref.docType, docId: ref.docId, date: ref.date,
      })));
    }
    if (m.settlement?.length) {
      await tx.insert(settlementMovements).values(m.settlement.map((s) => ({
        counterpartyId: s.counterpartyId, amountDeltaKopecks: s.amountDeltaKopecks,
        docType: ref.docType, docId: ref.docId, date: ref.date,
      })));
    }
    if (m.cash?.length) {
      await tx.insert(cashMovements).values(m.cash.map((c) => ({
        cashAccountId: c.cashAccountId, amountDeltaKopecks: c.amountDeltaKopecks,
        cashflowCategoryId: c.cashflowCategoryId ?? null,
        docType: ref.docType, docId: ref.docId, date: ref.date,
      })));
    }
  });
}

export async function unpostDocument(db: Db, dt: DocTypeValue, docId: string): Promise<void> {
  await db.transaction(async (tx) => { await deleteMovements(tx as unknown as Db, dt, docId); });
}
